import { motion } from "framer-motion";
import "../styles/Card.css";

const CardAnimada = ({ title, data, onConfirm, onCancel }) => {
  const cardVariants = {
    hidden: { opacity: 0, y: -50 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.div
      className="card-animada"
      initial="hidden"
      animate="visible"
      exit="hidden"
      variants={cardVariants}
      transition={{ type: "spring", stiffness: 100, damping: 15 }}
    >
      <h3>{title}</h3>
      <div className="card-content">
        {Object.keys(data).map((key, index) => (
          <p key={index}>
            <strong>{key}:</strong> {data[key]}
          </p>
        ))}
      </div>
      <div className="button-group">
        <button className="btn-confirmar" onClick={onConfirm}>
          Editar
        </button>
        <button className="btn-cancelar" onClick={onCancel}>
          Cancelar
        </button>
      </div>
    </motion.div>
  );
};

export default CardAnimada;
